import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink, Trophy } from 'lucide-react';
import { trackFindClubEvent } from '@/utils/analytics';

const FUTWORK_REGISTRATION_URL = 'https://futwork.io/register/player/futwork-soccer-academy-players-4c66a629';

export function FutWorkCTA() {
  const handleCTAClick = () => {
    trackFindClubEvent('futwork_cta_clicked', { source: 'find_club_page' });
    window.open(FUTWORK_REGISTRATION_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="mt-8 p-6 bg-gradient-to-br from-primary/5 via-primary/10 to-background border border-primary/20 rounded-lg">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
            <Trophy className="w-5 h-5 text-primary" />
            <h3 className="text-lg font-semibold text-foreground">
              Don't have a club? Join FutWork Soccer Academy.
            </h3>
          </div>
          <p className="text-sm text-muted-foreground">
            Start your soccer journey with professional coaching and skill development
          </p>
        </div>
        <Button 
          onClick={handleCTAClick}
          size="lg"
          className="h-12 px-8 text-base font-medium min-w-[260px]"
        >
          Join FutWork Soccer Academy Now
          <ExternalLink className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
